export const MMDDYYYYFormat = {
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
};

